import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-announcement-dialog',
  template: `
    <div class="announcement-card">
      <!-- Close Icon -->
      <button mat-icon-button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>

      <img [src]="data.image" alt="Announcement" class="card-image">
      <h3 class="card-title">{{ data.title }}</h3>
      <p class="card-description">{{ data.description }}</p>
      <p class="card-expiry">Expiry: {{ data.endDate | date:'mediumDate' }}</p>
    </div>
  `,
  styles: [`
    .announcement-card {
      position: relative;
      text-align: center;
      padding: 20px;
    }

    .close-btn {
      position: absolute;
      top: 8px;
      right: 8px;
      color: #555;
    }

    .close-btn:hover {
      color: #000;
    }

    .card-image {
      width: 80%;
      max-height: 200px;
      object-fit: cover;
      border-radius: 8px;
      margin-bottom: 15px;
      margin-top: 25px;
    }

    .card-title {
      font-weight: 600;
      margin-bottom: 10px;
    }

    .card-description {
      font-size: 14px;
      margin-bottom: 15px;
    }

    .card-expiry {
      font-weight: 500;
      color: red;
    }
  `]
})
export class AnnouncementDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AnnouncementDialogComponent>
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
